import React from 'react';
import { useNavigate } from 'react-router-dom';

const relatedWorksList = [
  {
    path: '/works/canine-crown',
    title: 'Canine Crown',
    subtitle: 'Brand identity & packaging design for premium pet nutrition.',
    img: 'https://ascentbw.com/Images/CanineCrown/CanineCover.webp'
  },
  {
    path: '/works/mgr',
    title: 'MGR University',
    subtitle: 'Editorial design and print production of admissions prospectus.',
    img: 'https://ascentbw.com/Images/MGR/Mgr4.webp'
  },
  {
    path: '/works/windplus',
    title: 'Windplus',
    subtitle: 'Corporate website development for renewable energy platforms.',
    img: 'https://ascentbw.com/Images/Windplus/Full.webp'
  },
  {
    path: '/works/feston',
    title: 'Feston',
    subtitle: 'Immersive exhibition stall design and spatial branding.',
    img: 'https://ascentbw.com/Images/Feston/cover.webp'
  },
  {
    path: '/works/atss',
    title: 'ATSS Technologies',
    subtitle: 'Complete brand communication and security automation catalogs.',
    img: 'https://ascentbw.com/Images/Atss/cover.webp'
  },
  {
    path: '/works/aulpha',
    title: 'Aulpha',
    subtitle: 'Editorial design and print production of corporate prospectus.',
    img: 'https://ascentbw.com/Images/Aulpha/cover.webp'
  },
  {
    path: '/works/plugzmart',
    title: 'Plugzmart',
    subtitle: 'Corporate video presentation and EV charging digital showcases.',
    img: 'https://ascentbw.com/Images/Plugzmart/Full1.webp'
  },
  {
    path: '/works/smileaura',
    title: 'Smileaura',
    subtitle: 'Aesthetic dental branding and motion graphics campaigns.',
    img: 'https://ascentbw.com/Images/Smileaura/Full1.webp'
  },
  {
    path: '/works/gangasweets',
    title: 'Ganga Sweets',
    subtitle: 'Heritage sweet packaging design and culinary visual branding.',
    img: 'https://ascentbw.com/Images/Gangasweets/Full1.webp'
  },
  {
    path: '/works/velammalnexux',
    title: 'Velammal Nexus',
    subtitle: 'Educational branding, promotional video production, and social marketing campaigns.',
    img: 'https://ascentbw.com/Images/VelammalNexux/Full5.webp'
  },
  {
    path: '/works/swathy',
    title: 'Swathy',
    subtitle: 'Heritage sweet packaging design, printing management, and dynamic promotional video campaigns.',
    img: 'https://ascentbw.com/Images/Swathy/Full3.webp'
  },
  {
    path: '/works/jkb',
    title: 'JKB',
    subtitle: 'Grand-scale outdoor billboards and premium brochures for JKB Housing.',
    img: 'https://ascentbw.com/Images/JKB/Full1.webp'
  },
  {
    path: '/works/apramatt',
    title: 'Apramatt',
    subtitle: 'Brand identity, packaging systems, and catalog design for photography gear.',
    img: 'https://ascentbw.com/Images/Apramatt/Full1.webp'
  },
  {
    path: '/works/deye',
    title: 'Deye',
    subtitle: 'Brand identity, brochure design, and web platform development for smart solar technologies.',
    img: 'https://ascentbw.com/Images/Deye/Full1.webp'
  },
  {
    path: '/works/aiwo',
    title: 'AIWO',
    subtitle: 'Sleek supplement packaging, brand identity, and marketing collateral for health optimization.',
    img: 'https://ascentbw.com/Images/Aiwo/Full1.webp'
  }
];

export default function RelatedWorks({ excludePath }) {
  const navigate = useNavigate();
  // Select a dynamic random mix of 3 works, stable for the duration of the component mount
  const mixedWorks = React.useMemo(() => {
    const filtered = relatedWorksList.filter(work => work.path !== excludePath);
    const shuffled = [...filtered].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 3);
  }, [excludePath]);

  return (
    <section className="project-dark-section related-works-blue-bg">
      <style>{`
        .project-dark-section.related-works-blue-bg {
          background-color: #001233 !important;
        }
        .related-works-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }
        @media (max-width: 991px) {
          .related-works-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 767px) {
          .related-works-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="dark-section-header">
        <h2>Explore More Works</h2>
        <p>
          Discover how we partner with forward-thinking brands across strategy, design, and digital activation to build impact.
        </p>
      </div>

      <div className="related-works-grid">
        {mixedWorks.map((work, index) => (
          <div 
            key={index} 
            className="dark-card" 
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(work.path);
              window.scrollTo(0, 0);
            }}
          >
            <img src={work.img} alt={work.title} />
            <div className="dark-card-content">
              <h3>{work.title}</h3>
              <p>{work.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
